import {
  isSchemaMismatched,
  subscribeToSchemaMismatch,
} from '@anchorage/graphql/client';
import { useSyncExternalStore } from 'react';

/**
 * True once any request on this tab has failed with GRAPHQL_VALIDATION_FAILED
 * — proof the tab's bundle predates the live schema. Latched for the tab's
 * lifetime; there is no "un-stale" transition.
 */
export function useSchemaMismatch(): boolean {
  return useSyncExternalStore(
    subscribeToSchemaMismatch,
    isSchemaMismatched,
    // Server render: no request has failed yet, so never stale.
    () => false,
  );
}
